// src/com/dc_temp_info/DcTempInfoDict.js
import { InputType, TableColumnType } from "../../value/AppConst";
import IsValid from "../../value/IsValid";

// DC 별 기준온도 설정, dc_temp_info
const Dict = {
    // toAdd, toEdit : mark if need to submit for mutation
    dcCd : {
		id: 'dcCd', label: '물류센터', required: true, toAdd: true, toEdit: true, // 자신의 센터만. 자동입력
	}, // varchar(3)
    tempYn : {
		id: 'tempYn', label: '온도체크 사용',
		type: InputType.radioForBoolean, required: true, toAdd: true, toEdit: true,
		trueValue: 'Y', falseValue: 'N',
        select: {true:'ON', false:'Off'},
	}, // enum('Y','N')
    tempDeviation : {
		id: 'tempDeviation', label: '온도 편차',
		type: InputType.number, required: false, toAdd: true, toEdit: true,
		check: (value) => {return value >= -7.0 && value <= 7.0},
	}, // double
    tempStartTime : {
		id: 'tempStartTime', label: '온도체크시작(시)',
		type: InputType.select, required: false, toAdd: true, toEdit: true,
		selectList: Array.from({length:24}, (v,i)=>{return {tempStartTime:i, label:i+'시'}}),
	}, // int(11)
    tempGapMinute : {
		id: 'tempGapMinute', label: '체크간격(분)',
		type: InputType.radio, required: false, toAdd: true, toEdit: true,
		selectList: [
            {tempGapMinute:10, label:'10분'},
            {tempGapMinute:15, label:'15분'},
            {tempGapMinute:20, label:'20분'},
            {tempGapMinute:30, label:'30분'},
            {tempGapMinute:40, label:'40분'},
            {tempGapMinute:60, label:'60분'},
        ]
	}, // int(11)
    tempSet1 : {
		id: 'tempSet1', label: '기준온도(-21℃)',
		type: InputType.number, required: false, toAdd: true, toEdit: true,
		check: (value) => {return value >= -30 && value <= 30},
	}, // int(11)
    tempSet2St : {
		id: 'tempSet2St', label: '하한',
		type: InputType.number, required: false, toAdd: true, toEdit: true,
		check: (value) => {return value >= -30 && value <= 30},
	}, // int(11)
    tempSet2En : {
		id: 'tempSet2En', label: '상한',
		type: InputType.number, required: false, toAdd: true, toEdit: true,
		check: (value) => {return value >= -30 && value <= 30},
	}, // int(11)
    tempSet3St : {
		id: 'tempSet3St', label: '하한',
		type: InputType.number, required: false, toAdd: true, toEdit: true,
		check: (value) => {return value >= -30 && value <= 30},
	}, // int(11)
    tempSet3En : {
		id: 'tempSet3En', label: '상한',
		type: InputType.number, required: false, toAdd: true, toEdit: true,
		check: (value) => {return value >= -30 && value <= 30},
	}, // int(11)
    tempSet4St : {
		id: 'tempSet4St', label: '하한',
		type: InputType.number, required: false, toAdd: true, toEdit: true,
		check: (value) => {return value >= -30 && value <= 30},
	}, // int(11)
    tempSet4En : {
		id: 'tempSet4En', label: '상한',
		type: InputType.number, required: false, toAdd: true, toEdit: true,
		check: (value) => {return value >= -30 && value <= 30},
	}, // int(11)
    smsYn : {
		id: 'smsYn', label: 'SMS 전송',
		type: InputType.radioForBoolean, required: false, toAdd: true, toEdit: true,
		trueValue: 'Y', falseValue: 'N',
        select: {true:'ON', false:'Off'},
	}, // enum('N','Y')
    rcvrTelno1 : {
		id: 'rcvrTelno1', label: 'SMS 수신 전화 1',
		type: InputType.tel, required: false, toAdd: true, toEdit: true,
		check: (value) => {return IsValid.string(value, 0, 64)},
	}, // varchar(64)
    rcvrTelno2 : {
		id: 'rcvrTelno2', label: 'SMS 수신 전화 2',
		type: InputType.tel, required: false, toAdd: true, toEdit: true,
		check: (value) => {return IsValid.string(value, 0, 64)},
	}, // varchar(64)
    rcvrTelno3 : {
		id: 'rcvrTelno3', label: 'SMS 수신 전화 3',
		type: InputType.tel, required: false, toAdd: true, toEdit: true,
		check: (value) => {return IsValid.string(value, 0, 64)},
	}, // varchar(64)
    dcName : { id: 'dcName', label: '물류센터' }, // varchar(20)
    
};

/**
 * DC_TEMP_INFO React Component Dictionary for Input and Output
 * Project: NewTOP for cloud
 * 2024-12-05 17:16:32 using DbdbTap
 * https://www.dbdbtap.com
 */
export const DcTempInfoDictionary = {
    inputMap: Dict,
    errorTitle: {
        // Add: '____ 등록 오류',
        Edit: '온도관제 설정 오류',
        Remove: '온도관제 설정 삭제 오류',
        Get: '온도관제 설정 조회 오류',
    },
    tableProps: {
        tableId: 'dcTempInfoTable',
        uniqueKey: 'dcCd',
        flexOption: {
            multiChecker:false,
            hideFirstTopButton: false,
            hideColumnConfig: true,
            hideBubble: false,
            growToFill: true,
        },
        columns: [
            { id: 'dcName', label: Dict.dcName.label, width: 120, show: true, option:{align: 'inherit', type:TableColumnType.TEXT} },
            { id: 'tempYn', label: Dict.tempYn.label, width: 100, show: true, option:{align: 'center', print:(r,i,v)=>v==='Y'?'사용':<span style={{color:'#999'}}>-</span>} },
            {
                id: 'tempDeviation', label: Dict.tempDeviation.label, width: 90, show: true,
                option:{
                    align: 'center',
                    print: (r,i,v)=>{
                        if(r.tempYn==='Y') {
                            return r.tempDeviation;
                        }
                        else return '-';
                    }
                }
            },
            {
                id: 'tempStartTime', label: Dict.tempStartTime.label, width: 120, show: true,
                option:{
                    align: 'center',
                    print: (r,i,v)=>{
                        if(r.tempYn==='Y') {
                            return r.tempStartTime+'시';
                        }
                        else return '-';
                    }
                }
            },
            {
                id: 'tempGapMinute', label: Dict.tempGapMinute.label, width: 100, show: true,
                option:{
                    align: 'center',
                    print: (r,i,v)=>{
                        if(r.tempYn==='Y') {
                            return r.tempGapMinute+'분';
                        }
                        else return '-';
                    }
                }
            },
            {
                id: 'tempSet1', label: Dict.tempSet1.label, width: 120, show: true,
                option:{
                    align: 'center',
                    print: (r,i,v)=>{
                        if(r.tempYn==='Y') {
                            return r.tempSet1;
                        }
                        else return '-';
                    }
                }
            },
            {
                id: 'tempSet2St', label: '기준온도(1℃)', width: 120, show: true,
                option:{
                    align: 'center',
                    print: (r,i,v)=>{
                        if(r.tempYn==='Y') {
                            return r.tempSet2St + ' ~ ' + r.tempSet2En;
                        }
                        else return '-';
                    }
                }
            },
            {
                id: 'tempSet3St', label: '기준온도(5℃)', width: 120, show: true,
                option:{
                    align: 'center',
                    print: (r,i,v)=>{
                        if(r.tempYn==='Y') {
                            return r.tempSet3St + ' ~ ' + r.tempSet3En;
                        }
                        else return '-';
                    }
                }
            },
            {
                id: 'tempSet4St', label: '기준온도(10℃)', width: 120, show: true,
                option:{
                    align: 'center',
                    print: (r,i,v)=>{
                        if(r.tempYn==='Y') {
                            return r.tempSet4St + ' ~ ' + r.tempSet4En;
                        }
                        else return '-';
                    }
                }
            },
            { id: 'regDate', label: "등록일", width: 120, show: true, option:{align: 'center', print:(r,i,v)=>v?v.substring(0,10):'-'} },
            { id: 'regUserName', label: "등록자", width: 80, show: true, option:{align: 'center', type:TableColumnType.TEXT} },
            //print using getTableColumnOption(c,t,i)
            // { id: 'tempChkCount', label: Dict.tempChkCount.label, width: 120, show: true, option:{align: 'right', type:TableColumnType.INTEGER} },
            //{ id: 'tempSet2En', label: Dict.tempSet2En.label, width: 120, show: true, option:{align: 'right', type:TableColumnType.INTEGER} },
            /* { id: 'tempCalculSet1', label: Dict.tempCalculSet1.label, width: 120, show: true, option:{align: 'right', type:TableColumnType.INTEGER} },
            { id: 'tempCalculSet2St', label: Dict.tempCalculSet2St.label, width: 120, show: true, option:{align: 'right', type:TableColumnType.INTEGER} },
            { id: 'tempCalculSet2En', label: Dict.tempCalculSet2En.label, width: 120, show: true, option:{align: 'right', type:TableColumnType.INTEGER} },
            { id: 'tempCalculSet3St', label: Dict.tempCalculSet3St.label, width: 120, show: true, option:{align: 'right', type:TableColumnType.INTEGER} },
            { id: 'tempCalculSet3En', label: Dict.tempCalculSet3En.label, width: 120, show: true, option:{align: 'right', type:TableColumnType.INTEGER} },
            { id: 'tempCalculSet4St', label: Dict.tempCalculSet4St.label, width: 120, show: true, option:{align: 'right', type:TableColumnType.INTEGER} },
            { id: 'tempCalculSet4En', label: Dict.tempCalculSet4En.label, width: 120, show: true, option:{align: 'right', type:TableColumnType.INTEGER} },
            { id: 'smsYn', label: Dict.smsYn.label, width: 120, show: true, option:{align: 'inherit', type:TableColumnType.TEXT} },
            { id: 'rcvrTelno1', label: Dict.rcvrTelno1.label, width: 120, show: true, option:{align: 'inherit', type:TableColumnType.TEXT} },
            { id: 'rcvrTelno2', label: Dict.rcvrTelno2.label, width: 120, show: true, option:{align: 'inherit', type:TableColumnType.TEXT} },
            { id: 'rcvrTelno3', label: Dict.rcvrTelno3.label, width: 120, show: true, option:{align: 'inherit', type:TableColumnType.TEXT} },
            { id: 'memo', label: Dict.memo.label, width: 120, show: true, option:{align: 'inherit', type:TableColumnType.TEXT} },
            { id: 'regUser', label: "regUser", width: 120, show: true, option:{align: 'inherit', type:TableColumnType.TEXT} }, */
        ]
    },
};
